import axios from '@fs/zion-axios'
import { useUser } from '@fs/zion-user'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'

const fetchShowNamesInRomanScript = async (cisId) => {
  if (!cisId) {
    return false
  }
  const { data } = await axios.get(
    `/service/cmn/user-preferences/users/${cisId}/preferences/tree.showNamesInRomanScript`
  )
  return !!data?.value
}

const updateShowNamesInRomanScript = (cisId, enable) =>
  axios.put(`/service/cmn/user-preferences/users/${cisId}/preferences/tree.showNamesInRomanScript`, { value: enable })

export default function useShowNamesInRomanScript() {
  const { cisId } = useUser()
  const { data: remoteShowNamesInRomanScript, loading: showNamesInRomanScriptLoading } = useFetchData(
    fetchShowNamesInRomanScript,
    {
      initialData: false,
      requestFnArg: cisId,
    }
  )

  const { state: localShowNamesInRomanScript, handleChangeState: handleChangeShowNamesInRomanScript } = useStateManager(
    (checked) => updateShowNamesInRomanScript(cisId, checked)
  )

  const showNamesInRomanScript = localShowNamesInRomanScript ?? remoteShowNamesInRomanScript

  return {
    showNamesInRomanScript,
    showNamesInRomanScriptLoading,
    handleChangeShowNamesInRomanScript,
  }
}
